module.exports = __webpack_public_path__ + "img/02.6b831d60.jpg";